import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 306.001 306.001"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M249.142 0H120.713a7.5 7.5 0 0 0 0 15h54.958l-58.527 276H56.859a7.5 7.5 0 0 0 0 15h66.339l.028.001.017-.001h62.044a7.5 7.5 0 0 0 0-15h-52.811l58.527-276h58.138a7.5 7.5 0 0 0 .001-15" }, null, -1)
  ])))
}
export default { render: render }